<template>
    <div>
        <!-- <div>{{ eventId }}：{{ eventName }}</div> -->
        <el-alert :title="`${eventId}：${eventName}`" type="info" :closable="false"></el-alert>
        <div class="page-filter-box MT10">
            <el-row :gutter="20">
                <el-col :sm="12" :md="8" :xl="4">
                    <el-input size="small" v-model="params.trackPath" placeholder="请输入跟踪参数"></el-input>
                </el-col>
                <el-col :sm="12" :md="8" :xl="4">
                    <el-date-picker size="small" v-model="datetimerange" type="daterange" range-separator="-"
                        value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" :clearable="false"
                        style="width:100%" unlink-panels :picker-options="pickerOptions">
                    </el-date-picker>
                </el-col>
                <el-col :sm="12" :md="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/eventManage/statistics/export')" type="primary" size="small" @click="download()" :loading="downLoading">导出数据</el-button>
        </div>
        <el-alert title="目前仅支持最多360天的数据" show-icon type="warning"></el-alert>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="timeView" label="日期" show-overflow-tooltip></el-table-column>
                <el-table-column label="总数据">
                    <template slot-scope="{row} = scope">
                        <div>事件数：{{ row.totalNum }}</div>
                        <div>用户数：{{ row.totalUserNum }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="iOS">
                    <template slot-scope="{row} = scope">
                        <div>事件数：{{ row.iosTotalNum }}</div>
                        <div>用户数：{{ row.iosTotalUserNum }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="Android">
                    <template slot-scope="{row} = scope">
                        <div>事件数：{{ row.androidTotalNum }}</div>
                        <div>用户数：{{ row.androidTotalUserNum }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="WAP">
                    <template slot-scope="{row} = scope">
                        <div>事件数：{{ row.wapTotalNum }}</div>
                        <div>用户数：{{ row.wapTotalUserNum }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="抖音小程序">
                    <template slot-scope="{row} = scope">
                        <div>事件数：{{ row.byteTotalNum }}</div>
                        <div>用户数：{{ row.byteTotalUserNum }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="微信小程序">
                    <template slot-scope="{row} = scope">
                        <div>事件数：{{ row.wxTotalNum }}</div>
                        <div>用户数：{{ row.wxTotalUserNum }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="支付宝小程序">
                    <template slot-scope="{row} = scope">
                        <div>事件数：{{ row.aliTotalNum }}</div>
                        <div>用户数：{{ row.aliTotalUserNum }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="小红书小程序">
                    <template slot-scope="{row} = scope">
                        <div>事件数：{{ row.redTotalNum }}</div>
                        <div>用户数：{{ row.redTotalUserNum }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { downloadFileTmp } from '@/assets/js/commonApi.js';
let startTime, endTime;
const defaultParams = {
    pageNo: 1,
    startTime: "",
    endTime: "",
    trackPath: "",
}
export default {
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    data() {
        endTime = this.$utils.formatDate((new Date().getTime()), 'yyyy-MM-dd') + ' 23:59:59';
        startTime = this.$utils.formatDate((new Date().getTime() - 3600 * 1000 * 24 * 30), 'yyyy-MM-dd') + ' 00:00:00';
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
                id: this.id
            },
            datetimerange: [this.$route.query.startTime || startTime, this.$route.query.endTime || endTime],
            pickerMinDate1: "",//第一次选中的时间
            pickerOptions: {
                onPick: obj => {
                    this.pickerMinDate1 = new Date(obj.minDate).getTime();
                },
                disabledDate: (time) => {
                    if (this.pickerMinDate1 && time.getTime() <= new Date(endTime).getTime()) {
                        const day1 = 360 * 24 * 3600 * 1000;
                        let maxTime = this.pickerMinDate1 + day1;
                        let minTime = this.pickerMinDate1 - day1;
                        return time.getTime() > maxTime || time.getTime() < minTime;
                    } else {
                        return time.getTime() > new Date(endTime).getTime();
                    }
                }
            },
            listLoading: true,
            downLoading: false,
            eventId: "",
            eventName: ""
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || '',
            }
            this.listLoading = true;
            this.$request({
                url: "/eventManage/statistics",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.eventId = result?.eventId;
                        this.eventName = result?.eventName;
                        this.data = result?.pageData;
                        this.dataList = this.data?.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [startTime, endTime];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
                id: this.id
            };
            this.getDataList();
        },
        //导出
        download() {
            let filePath;
            this.downLoading = true;
            this.$request({
                url: '/eventManage/statistics/export',
                method: 'POST',
                data: {
                    ...this.params,
                },
            }).then(res => {
                const { state, msg, result } = res.data;
                if (state == 1 && result) {
                    filePath = result.url;
                    downloadFileTmp(filePath, `${this.eventId}${this.eventName}.` + this.$utils.getFileType(filePath));
                    this.downLoading = false;
                } else {
                    this.downLoading = false;
                    return this.$message.error(msg || '下载失败');
                }
            }).catch(() => {
                this.$message.error('请求错误');
            });
        },
    }
}
</script>
<style lang="scss" scoped></style>